import React, { useEffect, useRef, useState } from "react";

const HeroQuoteSection = ({ quoteKo, quoteEn }) => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const element = sectionRef.current;
    if (!element) return;

    const getScrollParent = (node) => {
      let current = node.parentElement;
      while (current) {
        const style = window.getComputedStyle(current);
        const overflowY = style.overflowY;
        if ((overflowY === "auto" || overflowY === "scroll") && current.scrollHeight > current.clientHeight) {
          return current;
        }
        current = current.parentElement;
      }
      return null;
    };

    const scrollParent = getScrollParent(element);
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { root: scrollParent, threshold: 0.35 }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="w-full bg-white !m-0 block rounded-none">
      <div className="px-6 py-12 sm:px-10 sm:py-16 md:px-14 md:py-20 flex items-center justify-center text-center">
        <div
          className={`max-w-[820px] transition-all duration-700 ease-out ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
        >
          <p className="text-[22px] sm:text-[30px] md:text-[36px] font-black text-slate-900 leading-tight">
            {quoteKo}
          </p>
          <p className="mt-0 text-[12px] sm:text-[13px] font-bold tracking-widest text-slate-500">
            {quoteEn}
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroQuoteSection;
